// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"94b2e9f9","498":"12698ef4","513":"98f716c8","787":"d4aba7ab"}[chunkId] + ".chunk.js";
};